import { render, staticRenderFns } from "./PcIndex.vue?vue&type=template&id=7b16cf40&scoped=true"
import script from "./PcIndex.vue?vue&type=script&lang=js"
export * from "./PcIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b16cf40",
  null
  
)

export default component.exports